"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var lodash_1 = require("lodash");
var makeListLayoutStyling_1 = __importDefault(require("./makeListLayoutStyling"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var ListLayout = function (_a) {
    var children = _a.children, columns = _a.columns;
    var styles = (0, makeListLayoutStyling_1.default)(columns);
    var renderChild = function (child, index) {
        return ((0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ item: true, xs: 12, mobileLarge: 12 / columns, "data-testid": "grid-".concat(index), css: styles.item }, { children: child }), index));
    };
    return ((0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ container: true, justifyContent: "flex-start", css: styles.container, "data-testid": "list-layout-container" }, { children: (0, lodash_1.map)(children, renderChild) })));
};
ListLayout.defaultProps = defaultProps_1.default;
exports.default = ListLayout;
//# sourceMappingURL=ListLayout.js.map